<template>
  <div class="container  ">
    <div class="card impressum-card p-5">
      <h1 class="mb-4 text-center">Impressum</h1>
      <h2>DICHIARANTE</h2>
      <p><strong>Company Name:</strong>  POORENT DI ALIREZA KEIMANESH</p>
      <p><strong>N. di iscrizione al Registro Imprese:</strong> 
        1726626 CCIAA di: RM</p>
      <p><strong>Cod.fiscale:</strong> KMNLRZ82C22Z224W Partita IVA: 14289881006
        Sede Legale</p>
      <p><strong>Via/piazza: </strong> *PIAZZA DEL GESU SNC CAP: * 00186 Comune: * ROMA Prov. RM</p>
      <p><strong>Recapiti:</strong> PEC: * alirezakeimanesh@pec.it</p>
      <h2>NOMINATIVI</h2>
      <p><strong>Ruolo:</strong> TITOLARE FIRMATARIO</p>
      <p><strong>Cognome:</strong> KEIMANESH Nome: ALIREZA</p>
      <p><strong>Codice Fiscale:</strong> KMNLRZ82C22Z224W</p>
      <p><strong>Sesso:</strong> M Cittadinanza: IRAN</p>
      <p><strong>Dati di nascita</strong> Data: 22/03/1982 Comune:* IRAN Stato: IRAN</p>
      <p><strong>Residenza</strong> Via/piazza: * VIA DEI PINI n. 23</p>
      <p><strong>CAP: </strong> * 00013 Comune: * FONTE NUOVA Prov. RM
        Recapiti</p>
      <p><strong>Email:</strong> POOYAN_KEIMANESH@YAHOO.COM PEC: * alirezakeimanesh@pec.it</p>
      <p><strong>Cellulare:</strong> 3806852464 </p>
      
      <p>
        Permesso di soggiorno n. 13464987 rilasciato da QUESTURA il 30/05/2018 con scadenz appartenente a Unione Europea
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImpressumPage",
};
</script>

<style>
 @import "@/assets/css/impressum.css"
</style>